











































import Vue from "vue";
import StatusLine from "@/components/Cluster/StatusLine.vue";

function toFixed(value: number, index = 2) {
  if (!value && value !== 0) return "";
  return value.toFixed(index).replace(".".padEnd(index + 1, "0"), "");
}

const stepOption = [
  { label: "1分钟", value: "1m" },
  { label: "10分钟", value: "10m" },
  { label: "30分钟", value: "30m" },
  { label: "1小时", value: "1h" },
  { label: "1天", value: "24h" }
];

const monitor = [
  {
    title: "CPU使用情况(%)",
    type: "node_cpu_utilisation{(node)}",
    format: (value: string) => toFixed(parseFloat(value))
  },
  {
    title: "CPU平均负载",
    type: "{__name__=~'(node_load1|node_load5|node_load15)',(node)}",
    legend: true,
    format: (value: string) => toFixed(parseFloat(value))
  },
  {
    title: "内存使用情况(%)",
    type: "node_memory_utilisation{(node)}",
    format: (value: string) => toFixed(parseFloat(value))
  },
  {
    title: "磁盘利用率(%)",
    type: "node_disk_size_utilisation{(node)}",
    format: (value: string) => toFixed(parseFloat(value))
  },
  {
    title: "inode使用率(%)",
    type: "node_disk_inode_utilisation{(node)}",
    format: (value: string) => toFixed(parseFloat(value))
  }
];

export default Vue.extend({
  name: "Monitor",
  components: { StatusLine },
  props: {
    hostData: { type: Object }
  },
  data() {
    return {
      date: [] as Array<Date>,
      step: "1m",
      stepOption,
      monitor: JSON.parse(JSON.stringify(monitor)) as typeof monitor
    };
  },
  mounted() {
    this.init();
    this.setNode();
  },
  methods: {
    init() {
      const start = new Date();
      const end = new Date();

      start.setTime(start.getTime() - 3600 * 1000 * 2);
      // 默认选中 近两小时
      this.date = [start, end];
    },
    setNode() {
      this.monitor.forEach(item => {
        item.type = encodeURIComponent(
          item.type.replace("(node)", `node='${this.hostData.name}'`)
        );
      });
      this.getData();
    },
    getData() {
      this.$nextTick(() => {
        (this.$refs.line as Vue[]).forEach(line => {
          (line as any).getData();
        });
      });
    },
    getDefaultData() {
      const now = new Date().getTime();
      switch (this.step) {
        case "1m":
          this.$set(this, "date", [
            new Date(now - 2 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "10m":
          this.$set(this, "date", [
            new Date(now - 12 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "30m":
          this.$set(this, "date", [
            new Date(now - 24 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "1h":
          this.$set(this, "date", [
            new Date(now - 48 * 3600 * 1000),
            new Date(now)
          ]);
          break;
        case "24h":
          this.$set(this, "date", [
            new Date(now - 24 * 7 * 3600 * 1000),
            new Date(now)
          ]);
          break;
      }
      this.getData();
    }
  }
});
